import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  alpha,
  CircularProgress,
  useTheme,
} from '@mui/material';

const StatsCard = ({ 
  title, 
  value, 
  icon, 
  color, 
  customTheme, 
  subtitle = null,
  loading = false,
}) => {
  // Usar o tema padrão do MUI caso o customTheme não seja fornecido
  const defaultTheme = useTheme();
  const theme = customTheme || defaultTheme;
  
  return (
    <Card
      elevation={0}
      sx={{
        border: `1px solid ${alpha(color, 0.2)}`,
        borderRadius: 3,
        height: '100%',
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: t => t.palette.mode === 'dark'
            ? `0 10px 20px ${alpha(theme.palette.grey[700], 0.3)}`
            : `0 10px 20px ${alpha(theme.palette.grey[500], 0.1)}`,
        }
      }}
    >
      <Box sx={{ position: 'relative', overflow: 'hidden' }}>
        <Box 
          sx={{ 
            position: 'absolute', 
            width: 120, 
            height: 120, 
            bgcolor: t => t.palette.mode === 'dark'
              ? alpha(theme.palette.grey[500], 0.2)
              : alpha(theme.palette.grey[500], 0.1),
            borderRadius: '50%',
            top: -60,
            right: -60,
            filter: t => t.palette.mode === 'dark' ? 'blur(30px)' : 'none'
          }} 
        />
        <CardContent sx={{ textAlign: 'left', py: 3, px: 3, position: 'relative' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Typography 
              variant="subtitle2" 
              sx={{ 
                color: t => t.palette.mode === 'dark' 
                  ? alpha(theme.palette.common.white, 0.9)
                  : 'text.secondary'
              }}
            >
              {title}
            </Typography>
            <Avatar 
              sx={{ 
                bgcolor: t => t.palette.mode === 'dark'
                  ? alpha(color, 0.3)
                  : alpha(color, 0.1), 
                color: color, 
                width: 36, 
                height: 36 
              }}
            >
              {icon}
            </Avatar>
          </Box>
          {loading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
              <CircularProgress size={28} sx={{ color: color, opacity: 0.7 }} />
            </Box>
          ) : (
            <Typography 
              variant="h4" 
              component="div" 
              sx={{ 
                fontWeight: 700, 
                color: t => t.palette.mode === 'dark' 
                  ? alpha(theme.palette.common.white, 0.95)
                  : 'text.primary'
              }}
            >
              {value}
            </Typography>
          )}
          {subtitle && (
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'text.secondary', 
                mt: 1
              }}
            >
              {subtitle}
            </Typography>
          )}
        </CardContent>
      </Box>
    </Card>
  );
};

export default StatsCard; 